import { IMG } from '../assets';
import TRE1 from "../assets/tre1.png"
import TRE2 from "../assets/tre2.png"
import TRE3 from "../assets/tre3.png"
import TRE4 from "../assets/tre4.png"
export const doctor1 = {
  id: 1,
  // img: "https://media.istockphoto.com/id/1219598026/photo/cheerful-young-doctor-in-white-coat-smiling-while-looking-at-screen-of-his-phone-using.jpg?s=612x612&w=0&k=20&c=cVDxO4BULzau-fNoAQ3GpuqamDa1BZLm951awdJYfFI=",
  img: IMG.DOCTOR1,
  img2:IMG.DOC1,
  name: "DR. SALEM AL-QABANDI",
  designation: "SENIOR CONSULTANT",
  speciality: "PERIODONTICS & GENERAL DENTISTRY",
  text: "Research in Periodontal Bone Loss (University of Minnesota, United States), Fellowship in Oral Implantology (Implant Educators, Florida, United States)",
  education: [
    {
      heading: "Doctor of Medical Sciences and Certificate in Orthodontics",
      descriptions: [
        "Harvard University School of Dental Medicine, Boston, MA"
      ]
    },
    {
      heading: "Doctor of Dental Medicine (D.M.D)",
      descriptions: [
        "Boston University Goldman School of Dental Medicine, Boston, MA",
        "Magna Cum Laude"
      ]
    },
    // {
    //   heading: "Bachelor of Arts in Predental Sciences",
    //   descriptions: [
    //     "Boston University College of Arts and Sciences, Boston, MA",
    //     "Minor in Mathematics"
    //   ]
    // }
  ],
  memberships: [
    "American Association of Orthodontics",
    "College of Diplomates of the American Board of Orthodontics",
    "Harvard Society for the Advancement of Orthodontics",
    "Kuwait Orthodontic Society",
    "American Student Dental Association",
    "American Dental Association"
  ]
};
export const doctor2 = {
  id: 2,
  // img: "https://media.istockphoto.com/id/1219598026/photo/cheerful-young-doctor-in-white-coat-smiling-while-looking-at-screen-of-his-phone-using.jpg?s=612x612&w=0&k=20&c=cVDxO4BULzau-fNoAQ3GpuqamDa1BZLm951awdJYfFI=",
  img: IMG.DOCTOR2,
  img2:IMG.DOC2,
  name: "DR. MOHAMMAD AL NOURI",
  designation: "SENIOR CONSULTANT",
  speciality: "PERIODONTICS & GENERAL DENTISTRY",
  text: "Research in Periodontal Bone Loss (University of Minnesota, United States),Fellowship in Oral Implantology (Implant Educators, Florida, United States)",
  education: [
    {
      heading: "Pediatric Dentistry Residency",
      descriptions: [
        "University of Illinois at Chicago – College of Dentistry, 2016 – 2018",
        "Masters in Oral Sciences"
      ]
    },
    {
      heading: "Internationally-Trained Dentists Program",
      descriptions: [
        "University of Maryland– College of Dentistry, 2015 – 2016",
        "Advanced one year Program in Pediatric Dentistry"
      ]
    },
    {
      heading: "Bachelor’s of Dental Medicine (B.D.M.)",
      descriptions: [
        "Kuwait University, Faculty of Dentistry, 2010 – 2013",
        "Honors: Graduation with Distinction"
      ]
    },
    {
      heading: "Bachelor’s of Medical Science (B.Med.Sc.)",
      descriptions: [
        "Kuwait University, Faculty of Dentistry, 2006 – 2010",
        "Honors: Graduation with Distinction"
      ]
    }
  ],
  memberships: [
    "Illinois Society for Pediatric Dentists (ISPD)",
    "American Academy of Pediatric Dentistry (AAPD)",
    "Kuwait Dental Association",
    "The International Association for Dental Research (IADR)"
  ]
}
export const doctor3 = {
  id: 3,
  // img: "https://img.freepik.com/free-photo/doctors-day-handsome-brunette-cute-guy-medical-gown-with-hands-pocket_140725-162944.jpg",
  img: IMG.DOCTOR3,
  img2:IMG.DOC3,
  name: "DR. AHMAD AL-AWADHI",
  designation: "SENIOR CONSULTANT",
  speciality: "PERIODONTICS & GENERAL DENTISTRY ",
  text: "Research in Periodontal Bone Loss (University of Minnesota, United States),Fellowship in Oral Implantology (Implant Educators, Florida, United States)",
  education: [
    {
      heading: "Advance Prosthodontics Specialty Program",
      descriptions: [
        "Herman Ostrow School of Dentistry at USC, 2013"
      ]
    },
    {
      heading: "Masters of Academic Medicine",
      descriptions: [
        "Kerk School of Medicine at USC, 2011 – 2013"
      ]
    },
    {
      heading: "Dental License in California",
      descriptions: [
        "Western Regional Board Examination (WREBs)",
        "DEA and NPI"
      ]
    },
    {
      heading: "College of Surgeons of Ireland",
      descriptions: [
        "No specific program mentioned"
      ]
    }
  ],
  memberships: [
    "ADA member",
    "Member in American College of Prosthodontics (ACP) ",
    "Member in California Dental Association (CDA) UMKC and USC Alumni member ",
    "Member of Dent-Cal program in the State of California"

  ]
}
export const doctor4 = {
  id: 4,
  // img: "https://img.freepik.com/free-photo/doctors-day-handsome-brunette-cute-guy-medical-gown-with-hands-pocket_140725-162944.jpg",
  // img: IMG.DOCTOR3,
  img: IMG.DOCTOR4,
  img2:IMG.DOC4,
  name: "DR. SHAHAD AL SHEMALI",
  designation: "SENIOR CONSULTANT",
  speciality: "PERIODONTICS & GENERAL DENTISTRY ",
  text: "Research in Periodontal Bone Loss (University of Minnesota, United States),Fellowship in Oral Implantology (Implant Educators, Florida, United States)",
  education: [
    {
      heading: "Advance Prosthodontics Specialty Program",
      descriptions: [
        "Herman Ostrow School of Dentistry at USC, 2013"
      ]
    },
    {
      heading: "Masters of Academic Medicine",
      descriptions: [
        "Kerk School of Medicine at USC, 2011 – 2013"
      ]
    },
    {
      heading: "Dental License in California",
      descriptions: [
        "Western Regional Board Examination (WREBs)",
        "DEA and NPI"
      ]
    },
    {
      heading: "College of Surgeons of Ireland",
      descriptions: [
        "No specific program mentioned"
      ]
    }
  ],
  memberships: [
    "ADA member",
    "Member in American College of Prosthodontics (ACP) ",
    "Member in California Dental Association (CDA) UMKC and USC Alumni member ",
    "Member of Dent-Cal program in the State of California"

  ]
}
export const doctor5 = {
  id: 5,
  // img: "https://img.freepik.com/free-photo/doctors-day-handsome-brunette-cute-guy-medical-gown-with-hands-pocket_140725-162944.jpg",
  // img: IMG.DOCTOR3,
  img: IMG.DOCTOR5,
  img2:IMG.DOC5,
  name: "DR. AISHA TIFOUNI",
  designation: "SENIOR CONSULTANT",
  speciality: "PERIODONTICS & GENERAL DENTISTRY ",
  text: "Research in Periodontal Bone Loss (University of Minnesota, United States),Fellowship in Oral Implantology (Implant Educators, Florida, United States)",
  education: [
    {
      heading: "Advance Prosthodontics Specialty Program",
      descriptions: [
        "Herman Ostrow School of Dentistry at USC, 2013"
      ]
    },
    {
      heading: "Masters of Academic Medicine",
      descriptions: [
        "Kerk School of Medicine at USC, 2011 – 2013"
      ]
    },
    {
      heading: "Dental License in California",
      descriptions: [
        "Western Regional Board Examination (WREBs)",
        "DEA and NPI"
      ]
    },
    {
      heading: "College of Surgeons of Ireland",
      descriptions: [
        "No specific program mentioned"
      ]
    }
  ],
  memberships: [
    "ADA member",
    "Member in American College of Prosthodontics (ACP) ",
    "Member in California Dental Association (CDA) UMKC and USC Alumni member ",
    "Member of Dent-Cal program in the State of California"

  ]
}

export const treatment1 = {
  title: "Pedodontist ",
  subTitle: "(Pediatric Dentist)",
  img: TRE1,
  des: "Our pedodontists are dedicated to the oral health of children from infancy through their teen years. They have the experience and qualifications to care for a child’s teeth, gums, and mouth throughout the various stages of childhood.",
  services: [
    "Routine dental exams and cleanings",
    "Fluoride treatments and dental sealants to prevent cavities ",
    "Monitoring and managing dental development and growth",
    "Treatment of dental injuries like fractured or displaced teeth",
    "Advice on proper brushing and flossing techniques for kids",
    "Management of dental habits such as thumb sucking and pacifier use"

  ]
}
export const treatment2 = {
  title: "Orthodontist ",
  subTitle: "",
  img: TRE2,
  des: "Our orthodontists specialize in correcting teeth and jaw alignment, ensuring a healthy bite and an aesthetically pleasing smile. They offer treatments that can make a significant difference in both function and appearance.",
  services: [
    "Traditional metal braces and clear braces",
    "Invisalign and other clear aligner treatments",
    "Retainers to maintain the position of straightened teeth",
    "Treatment for malocclusion (improper bites)",
    "Jaw alignment surgeries",
    "Space maintainers for early loss of baby teeth"

  ]
}
export const treatment3 = {
  title: "Periodontist ",
  subTitle: "",
  img: TRE3,
  des: "Periodontists focus on the prevention, diagnosis, and treatment of periodontal disease (gum disease) and the placement of dental implants. They help maintain the health of the supporting structures of your teeth.",
  services: [
    "Deep cleaning (scaling and root planing) for gum disease",
    "Gum graft surgery to treat receding gums ",
    "Placement and maintenance of dental implants",
    "Regenerative procedures to restore lost bone and tissue",
    "Cosmetic periodontal procedures (crown lengthening, soft tissue grafts)",
    "Treatment of severe gum disease and complex cases"

  ]
}
export const treatment4 = {
  title: "Endodontist ",
  subTitle: "",
  img: TRE4,
  des: "Endodontists are experts in saving teeth through procedures involving the inner tissues of the teeth, known as the pulp. They are the specialists to see if you need a root canal or other complex dental treatments.",
  services: [
    "Root canal therapy to treat infected or damaged tooth pulp",
    "Endodontic retreatment for previously treated teeth that have not healed properly ",
    "Treatment of dental trauma and injuries",
    "Apicoectomy (surgical root canal treatment)",
    "Management of cracked teeth and dental pain",
    "Treatment of dental abscesses "

  ]
}
